const closeCollapse = (collapse: HTMLElement) => {
  collapse.style.overflowY = "hidden";
  collapse.style.height = "0";
  collapse.style.opacity = "0";
  collapse.classList.remove("open");
  collapse.style.removeProperty("overflow-y");
  collapse.style.removeProperty("height");
  collapse.style.removeProperty("opacity");
};

export default closeCollapse;
